import api from '@/shared/api/api';
import { StudyService } from '@/shared/api/protocol-ts/api/core/svc_study_connectweb';
import {
  DeleteStudyReq,
  DeleteStudyResp,
  UnsetStudyRawMeshViewerReq,
  UnsetStudyRawMeshViewerResp,
} from '@/shared/api/protocol-ts/api/core/svc_study_pb';
import { StorageService } from '@/shared/api/protocol-ts/api/core/svc_upload_connectweb';
import {
  CloseSessionReq,
  CloseSessionResp,
  FailSessionReq,
  FailSessionResp,
  NotifyFileUploadFinishedReq,
  NotifyFileUploadProgressReq,
  NotifyFileUploadProgressResp,
  NotifyFileUploadStartedReq,
  NotifyFileUploadStartedResp,
  StartUploadSessionReq,
  StartUploadSessionResp,
} from '@/shared/api/protocol-ts/api/core/svc_upload_pb';
import { UploadSession } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

import { notifyFileUploadFinishedRequest } from '../lib';

export type StorageRequestsType = keyof typeof StorageService.methods;

type StudyRequestsType = keyof typeof StudyService.methods;

const generateStorageThunk = createThunkGenerator<StorageRequestsType>(
  SliceName.storage,
);

const generateStudyThunk = createThunkGenerator<StudyRequestsType>(
  SliceName.study,
);

export const deleteStudy = generateStudyThunk<DeleteStudyReq, DeleteStudyResp>(
  'deleteStudy',
  api.study.deleteStudy,
);

export const unsetStudyRawMeshViewer = generateStudyThunk<
  UnsetStudyRawMeshViewerReq,
  UnsetStudyRawMeshViewerResp
>('unsetStudyRawMeshViewer', api.study.unsetStudyRawMeshViewer);

export const startUploadSession = generateStorageThunk<
  StartUploadSessionReq,
  StartUploadSessionResp
>('startUploadSession', api.storage.startUploadSession);

export const closeSession = generateStorageThunk<
  CloseSessionReq,
  CloseSessionResp
>('closeSession', api.storage.closeSession);

export const notifyFileUploadStarted = generateStorageThunk<
  NotifyFileUploadStartedReq,
  NotifyFileUploadStartedResp
>('notifyFileUploadStarted', api.storage.notifyFileUploadStarted);

export const notifyFileUploadProgress = generateStorageThunk<
  NotifyFileUploadProgressReq,
  NotifyFileUploadProgressResp
>('notifyFileUploadProgress', api.storage.notifyFileUploadProgress);

export const notifyFileUploadFinished = generateStorageThunk<
  NotifyFileUploadFinishedReq,
  UploadSession | undefined
>('notifyFileUploadFinished', notifyFileUploadFinishedRequest);

export const failSession = generateStorageThunk<
  FailSessionReq,
  FailSessionResp
>('failSession', api.storage.failSession);
